module.exports = __webpack_public_path__ + "img/ijin_menu.ac5de7eb.png";